type Props = {
	useLocalStorage?: boolean;
};

/**
 * Utility function to check if the user is authenticated.
 * It checks for the presence of a valid userId in the session object.
 *
 * @param props - Configuration options for authentication check
 * @param props.useLocalStorage - Whether to check authentication using local storage instead of the default method.
 * 																This is to optimistically check auth state without an API call.
 * 																False by default.
 * @return {Promise<boolean>} - True if the user is authenticated, false otherwise.
 */
export async function isUserAuthenticated({
	useLocalStorage = false,
}: Props = {}): Promise<boolean> {
	const session = window.valioApp?.session;

	if (useLocalStorage) {
		return await session.isLoggedInWithLocalStorage();
	}

	return await session.isLoggedIn();
}
